import { useCallback } from 'react';
import style from './style.module.scss';
import icon from '../../icons/icons.module.scss';
import { StatusIcon, type Selector } from '@n2-common/lib/useFootnotes';
import { useTranslation } from 'react-i18next';
import { joinNames } from '@n2-common/ui/helpers';

export function DocumentItem({
    info,
    deleteDocumentHandler,
    selectFootnote,
}: {
    info: DocumentInfo;
    deleteDocumentHandler: (documentId: string) => void;
    selectFootnote: Selector<DocumentInfo>;
}) {
    const { t } = useTranslation('common');
    // TODO: Prevent doubleclick!
    const onDeleteClick = useCallback(() => deleteDocumentHandler(info.id), [deleteDocumentHandler, info.id]);
    const isDeleteable = info.deleteable;

    return (
        <div
            className={style.documentItem}
            tabIndex={isDeleteable ? 0 : undefined}
            onKeyDown={(e) => isDeleteable && ['Enter', 'NumpadEnter'].includes(e.code) && onDeleteClick()}
       >
            <StatusIcon note={selectFootnote(info)} />
            <div className={style.fileName}>{info.filename}</div>
            {isDeleteable && (
                <div
                    className={joinNames(style.deleteButton, icon.iconClose)}
                    onClick={onDeleteClick}
                    title={t<string>('Sign.Documents.RemoveText')}
                ></div>
            )}
        </div>
    );
}

export type DocumentInfo = {
    /** Id to use for deletion. */
    id: string;
    /** Reference id from upload */
    ref: string;
    status: string;
    error?: string;
    filename: string;
    /** Document is received via trusted third party - ex in Norway SBL */
    trusted: boolean;
    deleteable: boolean;
};
